import React from 'react';
import ReactDOM from 'react-dom';
import ReactAudioPlayer from 'react-audio-player';

ReactDOM.render(
  <ReactAudioPlayer
    src="files/cops_or_me.mp3"
    controls
  />,
  document.querySelector('.app'),
);
